import React, { useEffect, useState } from "react";
import { fetchAxiosToken } from "../../../helpers/fetchAxiosToken";
import { ChatSelect } from "./ChatRoom";

export interface Chat {
    id: string;
    name: string;
    lastMessage: string;
    messageType: string;
    fromMe: boolean;
    isRead: boolean;
    sentAt: string;
    profilePicture: any;
    unread: number;
}

export const ChatsList = ({
    setChatSelect,
    chats30,
    setChats30,
    loadMore,
    hasMore,
    loading,
    setVista,
}: {
    setChatSelect: (id: ChatSelect) => void;
    chats30: Chat[];
    setChats30: React.Dispatch<React.SetStateAction<Chat[]>>;
    loadMore: () => void;
    hasMore: boolean;
    loading: boolean;
    setVista: React.Dispatch<React.SetStateAction<string>>;
}) => {
    const [showUnread, setShowUnread] = useState(false);

    const truncateMessage = (msg: string, max = 50) =>
        msg.length > max ? msg.slice(0, max) + "…" : msg;

    const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
        const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;

        if (
            scrollHeight - scrollTop <= clientHeight + 100 &&
            hasMore &&
            !loading
        ) {
            loadMore();
        }
    };

    const filtered = showUnread
        ? chats30.filter((c) => !c.isRead && !c.fromMe)
        : chats30;

    return (
        <div className="w-full">
            <div>
                <p className="text-lg font-bold">Chats</p>
                <div className="flex gap-3 mt-1">
                    <p
                        className={`px-3 py-1 ${
                            !showUnread
                                ? "text-green-700 bg-green-100"
                                : "text-slate-700 bg-slate-100"
                        } rounded-2xl cursor-pointer`}
                        onClick={() => setShowUnread(false)}>
                        Todos
                    </p>
                    <p
                        className={`px-3 py-1 ${
                            showUnread
                                ? "text-green-700 bg-green-100"
                                : "text-slate-700 bg-slate-100"
                        } rounded-2xl cursor-pointer`}
                        onClick={() => setShowUnread(true)}>
                        No leídos
                    </p>
                </div>
            </div>

            <div
                className="mt-2 h-[78vh] md:h-[68vh] overflow-y-auto overflow-x-hidden"
                onScroll={handleScroll}>
                {filtered.map((chat) => (
                    <div
                        key={chat.id}
                        onClick={() => {
                            // marque leído
                            setChats30((prev) =>
                                prev.map((c) =>
                                    c.id === chat.id
                                        ? { ...c, isRead: true, unread: 0 }
                                        : c
                                )
                            );
                            setChatSelect({
                                chatId: chat.id,
                                name: chat.name,
                                unread: chat.unread,
                            });
                            setVista("chatDetail");
                        }}
                        className={`
              grid grid-cols-[65%,35%] cursor-pointer hover:bg-slate-100 mt-2 p-1 rounded
              ${!chat.isRead && !chat.fromMe ? "bg-green-50" : ""}
            `}>
                        {/* … tu UI de cada chat … */}
                        <div className="pb-2 border-b border-b-slate-100">
                            <p className="font-medium">{chat.name}</p>
                            <p className="text-sm text-slate-600">
                                {chat.messageType === "text"
                                    ? truncateMessage(chat.lastMessage, 20)
                                    : chat.messageType === "link_preview" &&
                                      chat.lastMessage.length &&
                                      chat.lastMessage !== "Sin mensaje"
                                    ? truncateMessage(chat.lastMessage, 20)
                                    : chat.messageType}
                            </p>
                        </div>
                        <div className="flex flex-col items-center justify-center pb-2 border-b border-b-slate-100">
                            <p className="text-sm text-center text-slate-600">
                                {chat.sentAt}
                            </p>
                            {chat.unread > 0 && (
                                <span className="inline-flex items-center justify-center w-5 h-5 text-[10px] font-medium text-white bg-green-500 rounded-full">
                                    {chat.unread}
                                </span>
                            )}
                        </div>
                    </div>
                ))}

                {loading && (
                    <p className="my-2 text-sm text-center text-gray-500">
                        Cargando más…
                    </p>
                )}
                {!hasMore && (
                    <p className="my-2 text-sm text-center text-gray-400">
                        No hay más chats.
                    </p>
                )}
            </div>
        </div>
    );
};
